import { Core } from "@faire/design-tokens";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { eventsThemeColors } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import styled, { css } from "styled-components";
var StyledContainer = styled(Column).withConfig({
    componentId: "sc-7cfbdd03-0"
})([
    "min-width:192px;margin-bottom:",
    ";",
    "{min-width:256px;}",
    ""
], getSpacing("2x"), responsiveMediaQueries.tabletAndAbove, function(param) {
    var showMarketTreatment = param.$showMarketTreatment;
    return showMarketTreatment ? css([
        "background-color:",
        ";padding:",
        ";",
        "{padding:",
        ";}"
    ], eventsThemeColors.faireMarket.lightBackground, getSpacing("1x", 20), responsiveMediaQueries.tabletAndAbove, getSpacing(12, "2x")) : null;
});
var StyledHeader = styled(Typography).attrs({
    color: Core.text.subdued
}).withConfig({
    componentId: "sc-7cfbdd03-1"
})([
    "&&&{padding-left:0;",
    "{text-align:",
    ";}}"
], responsiveMediaQueries.tabletAndAbove, function(param) {
    var $leftAlignTitle = param.$leftAlignTitle;
    return $leftAlignTitle ? "left" : "center";
});
var StyledMainTitle = styled(Typography).attrs({
    forwardedAs: "h4",
    variant: "pageHeaderSerifRegular",
    truncate: true,
    color: Core.text.default
}).withConfig({
    componentId: "sc-7cfbdd03-2"
})([
    "&&&{padding-left:0;word-break:break-word;white-space:normal;",
    "{text-align:",
    ";}}"
], responsiveMediaQueries.tabletAndAbove, function(param) {
    var $leftAlignTitle = param.$leftAlignTitle;
    return $leftAlignTitle ? "left" : "center";
});
var StyledAuxiliaryTitle = styled(Typography).withConfig({
    componentId: "sc-7cfbdd03-3"
})([
    "text-align:right;"
]);
var StyledSubtitle = styled(Typography).attrs({
    color: Core.text.subdued
}).withConfig({
    componentId: "sc-7cfbdd03-4"
})([
    "&&&{padding-left:0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;",
    "{text-align:",
    ";}",
    "{white-space:pre-wrap;}}"
], responsiveMediaQueries.tabletAndAbove, function(param) {
    var $leftAlignTitle = param.$leftAlignTitle;
    return $leftAlignTitle ? "left" : "center";
}, responsiveMediaQueries.tabletAndBelow);
var StyledArrowCTAContainer = styled.div.withConfig({
    componentId: "sc-7cfbdd03-5"
})([
    "",
    ";"
], function(param) {
    var $isVisible = param.$isVisible;
    return !$isVisible ? css([
        "display:none;"
    ]) : "";
});
var StyledTextCTAContainer = styled.div.withConfig({
    componentId: "sc-7cfbdd03-6"
})([
    "white-space:nowrap;margin-top:",
    ";",
    ";"
], getSpacing(4), function(param) {
    var $isVisible = param.$isVisible;
    return !$isVisible ? css([
        "display:none;"
    ]) : "";
});
var StyledMainTitleRow = styled(Row).withConfig({
    componentId: "sc-7cfbdd03-7"
})([
    "",
    '{&[data-show-arrow-cta="true"]{padding-top:',
    ";}}"
], responsiveMediaQueries.mobile, getSpacing("1x"));
var StyledHeaderTaglineWrapper = styled(Column).attrs({
    gap: "1x"
}).withConfig({
    componentId: "sc-7cfbdd03-8"
})([
    ""
]);
export var TitleStyles;
(function(TitleStyles) {
    TitleStyles.Container = StyledContainer;
    TitleStyles.Header = StyledHeader;
    TitleStyles.HeaderTaglineWrapper = StyledHeaderTaglineWrapper;
    TitleStyles.MainTitle = StyledMainTitle;
    TitleStyles.MainTitleRow = StyledMainTitleRow;
    TitleStyles.AuxiliaryTitle = StyledAuxiliaryTitle;
    TitleStyles.AuxiliaryTitleText = StyledTextCTAContainer;
    TitleStyles.AuxiliaryTitleArrow = StyledArrowCTAContainer;
    TitleStyles.Subtitle = StyledSubtitle;
})(TitleStyles || (TitleStyles = {}));
